<script setup lang="ts">
import type { PageFeatureProps } from '#ui/types';
import lodashOmit from 'lodash-es/omit';

export interface StoryblokUiPageFeatureProps {
    blok: StoryblokUiPageFeature;
}

// PROPS
const { blok } = defineProps<StoryblokUiPageFeatureProps>();

// DATA
const to = computed(() => (blok.to ? storyblokResolveLink(blok.to) : undefined));
const pageFeatureProps = computed<PageFeatureProps>(() =>
    lodashOmit(storyblokOmitEmptyValues<StoryblokUiPageFeature>(blok), ['_uid', 'component', 'to', 'description'])
);
</script>

<template>
    <UPageFeature v-editable="blok" v-bind="pageFeatureProps" :to="to">
        <template v-if="blok.leading?.length" #leading>
            <StoryblokComponent v-for="l in blok.leading" :key="l._uid" :blok="l" />
        </template>
        <template v-if="!!blok.description" #description>
            <StoryblokRichTextOverride :doc="blok.description" class="max-w-none" />
        </template>
        <template v-if="blok.body?.length" #default>
            <StoryblokComponent v-for="b in blok.body" :key="b._uid" :blok="b" />
        </template>
    </UPageFeature>
</template>
